import { Spinner } from '@crow/ui/spinner';
import type { ComponentProps } from 'react';
import { Button } from './button';

/** Keeps the action's accessible label while preventing duplicate submission. */
export function PendingButton({ pending = false, pendingLabel, disabled, children, ...props }: Omit<ComponentProps<typeof Button>, 'asChild'> & {
  pending?: boolean;
  pendingLabel?: string;
}) {
  return <Button {...props} disabled={disabled || pending} aria-busy={pending || undefined}>
    {pending && <Spinner className="size-4" />}
    {pending && pendingLabel ? pendingLabel : children}
  </Button>;
}
